import { Box } from "@mui/material";
import React from "react";
import noLogo from "../../../../../shared/assets/images/noLogo.png"

interface CompanyLogoProps {
  src?: string;
  size?: number;
}

const CompanyLogo = ({ src, size = 74 }: CompanyLogoProps) => {
  return (
    <>
      <Box sx={{ height: size, width: size }}>
        <img
          className="aspect-square object-cover"
          style={{ border: "1px solid #C7C9CD", borderRadius: "4px" }}
          src={src || noLogo}
          alt=""
        />
      </Box>
    </>
  );
};
export default CompanyLogo;
